const config = {
    success: '成功申請提交。',
    Application_No: '閣下申請編號為',
    notice: '「 確認電郵通知 」已發往所登記之電郵郵箱',
    return: '返回系統主頁',
    // Gabriel End Here 29-May-2023
};
export default config;
